module.exports = __webpack_public_path__ + "static/media/forklift.2c6aefd3.png";